import { render, staticRenderFns } from "./ResetExpiredPassword.vue?vue&type=template&id=68758156"
import script from "./ResetExpiredPassword.vue?vue&type=script&lang=ts"
export * from "./ResetExpiredPassword.vue?vue&type=script&lang=ts"
import style0 from "./ResetExpiredPassword.vue?vue&type=style&index=0&id=68758156&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports